$("input[name='role']").change(function() {
    $(".card").removeClass("selected");
    $(this).closest(".card").addClass("selected");

    $("#loginBtn").prop("disabled", false);
});
